function hasTags(entry, tags) {
	entry.tagGroups?.forEach(g => {
		g.tags?.forEach(t => {
			tags = tags.filter(s => s !== t.slug);
		});
	});

	entry.profiles?.forEach(p => {
		if (!p.active) return;
		p.tagGroups?.forEach(g => {
			g.tags?.forEach(t => {
				tags = tags.filter(s => s !== t.slug);
			});
		});
	});

	return tags.length <= 0;
}

function listGeneral(list, faction) {
	const { children, options } = list;
	list.alerts = [];

	// Check points
	if (list.cost > list.points) {
		list.alerts.push({ message: "Total list cost exceeds the selected points limit." })
	}

	if (options?.groups?.length) {
		for (const g of options.groups) {
			if (g.active === false) continue;

			let count = 0;
			if (g.groups) {
				count = g.groups.reduce((prev, s) => prev + s.orphans.filter(o => o.selected).length, 0);
			} else {
				count = g.orphans.filter(o => o.selected).length;
			}

			if (count > g.maxOptions) {
				list.alerts.push({ message: `Selected ${g.name} are over the maximum (${g.maxOptions}).` });
			}
			if (count < g.minOptions) {
				list.alerts.push({ message: `Selected ${g.name} are below the minimum (${g.minOptions}).` });
			}
		}
	}

	const entryNames = {};
	const types = {};
	faction.entryGroups.forEach(g => {
		types[g.slug] = {
			name: g.name,
			count: 0,
		};
		if (list.points <= 500) {
			if (g.slug === "warlords") { g.min = 1; g.max = 1; }
			if (g.slug === "heroes") { g.min = 0; g.max = 1; }
			if (g.slug === "monsters") { g.min = 0; g.max = 0; }
		} else if (list.points <= 1000) {
			if (g.slug === "warlords") { g.min = 1; g.max = 1; }
			if (g.slug === "heroes") { g.min = 0; g.max = 2; }
			if (g.slug === "monsters") { g.min = 0; g.max = 1; }
		} else if (list.points <= 1500) {
			if (g.slug === "warlords") { g.min = 1; g.max = 2; }
			if (g.slug === "heroes") { g.min = 0; g.max = 3; }
			if (g.slug === "monsters") { g.min = 0; g.max = 1; }
		} else if (list.points <= 2000) {
			if (g.slug === "warlords") { g.min = 1; g.max = 2; }
			if (g.slug === "heroes") { g.min = 0; g.max = 4; }
			if (g.slug === "monsters") { g.min = 0; g.max = 2; }
		} else {
			if (g.slug === "warlords") { g.min = 1; g.max = 3; }
			if (g.slug === "heroes") { g.min = 0; g.max = 5; }
			if (g.slug === "monsters") { g.min = 0; g.max = 3; }
		}
		if (g.slug === "mainstay") { g.min = 0; g.max = 9999; }
		if (g.slug === "restricted") { g.min = 0; g.max = 9999; }
	});

	if (list.points <= 500) {
		types["warlords"].min = 1;
		types["warlords"].max = 1;
		types["heroes"].min = 0;
		types["heroes"].max = 1;
		if (types["monsters"]) types["monsters"].min = 0;
		if (types["monsters"]) types["monsters"].max = 0;
	} else if (list.points <= 1000) {
		types["warlords"].min = 1;
		types["warlords"].max = 1;
		types["heroes"].min = 0;
		types["heroes"].max = 2;
		if (types["monsters"]) types["monsters"].min = 0;
		if (types["monsters"]) types["monsters"].max = 1;
	} else if (list.points <= 1500) {
		types["warlords"].min = 1;
		types["warlords"].max = 2;
		types["heroes"].min = 0;
		types["heroes"].max = 3;
		if (types["monsters"]) types["monsters"].min = 0;
		if (types["monsters"]) types["monsters"].max = 1;
	} else if (list.points <= 2000) {
		types["warlords"].min = 1;
		types["warlords"].max = 2;
		types["heroes"].min = 0;
		types["heroes"].max = 4;
		if (types["monsters"]) types["monsters"].min = 0;
		if (types["monsters"]) types["monsters"].max = 2;
	} else {
		types["warlords"].min = 1;
		types["warlords"].max = 3;
		types["heroes"].min = 0;
		types["heroes"].max = 5;
		if (types["monsters"]) types["monsters"].min = 0;
		if (types["monsters"]) types["monsters"].max = 3;
	}
	types["mainstay"].min = 0;
	types["mainstay"].max = 9999;
	types["restricted"].min = 0;
	types["restricted"].max = 9999;

	const upgrades = [
		"bestowments",
		"eccentricities",
		"trove-finds",
		"hold-vaults",
		"tribal-artefacts",
		"lost-treasures",
		"rewards-of-discipline",
		"bestowed-relics",
		"gifts-of-the-glade",
		"patron-s-gifts",
		"regalia-of-the-orders"
	];
	const upgradeMap = {};

	const allowedMainstaySlugs = [...faction.entryGroups.find(g => g.slug === "mainstay").entrySlugs];
	let allowedRestrictedSlugs = [...faction.entryGroups.find(g => g.slug === "restricted").entrySlugs];
	const selectedMainstaySlugs = [];
	const selectedRestrictedSlugs = [];

	let countTheists = 0;
	let fredrik = false;

	children.forEach(c => {
		const { type, selections, children, entrySlug, listEntry, sizeSteps = 0, alerts } = c;
		const tagGroups = listEntry.tagGroups || listEntry.profiles?.[0]?.tagGroups || [];
		const rolesTags = tagGroups.find(g => g.slug === "battlefield-roles")?.tags;
		const rolesSlugs = rolesTags?.map(r => r.slug) || [];

		types[type].count++;
		if (type === "warlords" && rolesSlugs.includes("monster")) {
			types["monsters"].count++;
		}

		if (hasTags(listEntry, ["theist", "character"]) || (rolesSlugs.includes("theist") && type == "monsters")) countTheists++;
		if (entrySlug === "king-fredrik") fredrik = true;

		entryNames[listEntry.name] = (entryNames[listEntry.name] ?? 0) + 1;
		if (listEntry.name === "Bergont Raegh") entryNames["Ironclad Drake"] = (entryNames["Ironclad Drake"] ?? 0) + 1;
		if (listEntry.name === "Ferric Throne") entryNames["Stoneforged"] = (entryNames["Stoneforged"] ?? 0) + 1;
		if (listEntry.name === "Hellbringer Sorcerer") entryNames["Hellbringer Drake"] = (entryNames["Hellbringer Drake"] ?? 0) + 1;
		if (listEntry.name === "Apex Queen") entryNames["Apex Predator"] = (entryNames["Apex Predator"] ?? 0) + 1;
		if (listEntry.name === "Drum Beast Scion") entryNames["Drum Beast"] = (entryNames["Drum Beast"] ?? 0) + 1;
		if (listEntry.name === "Tontorr Chieftain") entryNames["Tontorr"] = (entryNames["Tontorr"] ?? 0) + 1;
		if (listEntry.name === "Winglord Predator") entryNames["Quatl"] = (entryNames["Quatl"] ?? 0) + 1;
		if (listEntry.name === "Theokrator") entryNames["Unhallowed Sepulcher"] = (entryNames["Unhallowed Sepulcher"] ?? 0) + 1;

		let maxSize = listEntry.maxSize;
		if (["mainstay", "restricted"].includes(type)) {
			if (rolesSlugs.includes("infantry")) {
				if (list.points <= 500) maxSize = 8;
				else if (list.points <= 1000) maxSize = 12;
				else if (list.points <= 1500) maxSize = 16;
				else if (list.points <= 2000) maxSize = 20;
				else maxSize = 24;
			} else if (rolesSlugs.filter(s => ["brute", "cavalry"].includes(s).length > 0)) {
				if (list.points <= 500) maxSize = 2;
				else if (list.points <= 1000) maxSize = 3;
				else if (list.points <= 1500) maxSize = 4
				else if (list.points <= 2000) maxSize = 5;
				else maxSize = 6;
			}
		}
		listEntry.maxSize = maxSize;

		if (listEntry.minSize + sizeSteps * listEntry.sizeStep > maxSize) {
			alerts.push({ message: `${listEntry.name} Models are over the maximum: ${maxSize}` });
		}

		if (type === "mainstay") {
			selectedMainstaySlugs.push(entrySlug);
		} else if (type === "restricted") {
			selectedRestrictedSlugs.push(entrySlug);
		} else {
			if (type === "warlords") {
				const promotedSlugs = listEntry.retinue?.map(r => r.slug) || [];
				const retinueOptions = listEntry.options?.groups?.find(g => g.slug === "retinue");
				if (retinueOptions) {
					promotedSlugs.push(...retinueOptions.orphans.filter(o => o.selected).map(s => s.slug));
				}
				allowedMainstaySlugs.push(...promotedSlugs);
				allowedRestrictedSlugs = allowedRestrictedSlugs.filter(s => !promotedSlugs.includes(s));
			}
		}

		const { groups = [] } = listEntry.options || {};
		const upgradeGroups = groups.filter(g => upgrades.includes(g.slug)) || [];
		upgradeGroups.forEach(u => {
			const { groups: subgroups = [], orphans = [] } = u;
			orphans.forEach(o => {
				if (o.selected) {
					upgradeMap[o.name] = upgradeMap[o.name] ? upgradeMap[o.name] + 1 : 1;
				}
			});

			subgroups.forEach(g => {
				g.orphans.forEach(o => {
					if (o.selected) {
						upgradeMap[o.name] = upgradeMap[o.name] ? upgradeMap[o.name] + 1 : 1;
					}
				});
			});
		})
	})

	if (fredrik && countTheists) {
		list.alerts.push({ message: `A Warband including King Fredrik cannot include any [Theist Character] or [Theist Monsters].` })
	}

	for (const [key, val] of Object.entries(entryNames)) {
		if (val > 1) {
			list.alerts.push({ message: `"${key}" appears more than once in the Warband.` })
		}
	}

	for (const type of Object.keys(types)) {
		const { min, max, count, name } = types[type];
		if (count < min) {
			list.alerts.push({ message: `${name} selections are below the minimum: ${min}` });
		}
		if (count > max) {
			list.alerts.push({ message: `${name} selections are above the maximum: ${max}` });
		}
	}

	const keys = Object.keys(upgradeMap);
	keys.forEach(k => {
		if (upgradeMap[k] > 1) {
			list.alerts.push({ message: `${k} can only appear once in the Army.` });
		}
	});

	selectedMainstaySlugs.forEach(s => {
		if (!allowedMainstaySlugs.includes(s)) {
			list.alerts.push({ message: `${faction.entries[s].name} is not a Mainstay Regiment.` });
		}
	});

	selectedRestrictedSlugs.forEach(s => {
		if (!allowedRestrictedSlugs.includes(s)) {
			list.alerts.push({ message: `${faction.entries[s].name} is not a Restricted Regiment.` });
		}
	});

	if (selectedRestrictedSlugs.length > selectedMainstaySlugs.length) {
		list.alerts.push({ message: "The Warband must not inlcude more Restricted Regiments than Mainstay." });
	}

	// if (options) {
	// 	const groups = options.groups || [];
	// 	for (const g of groups) {
	// 		if (g.active === false) continue;

	// 		const count = g.orphans.filter(o => o.selected).length;
	// 		if (count > g.maxOptions) {
	// 			list.alerts.push({ message: `Selected ${g.name} are over the maximum (${g.maxOptions}).` });
	// 		}
	// 		if (count < g.minOptions) {
	// 			list.alerts.push({ message: `Selected ${g.name} are below the minimum (${g.minOptions}).` });
	// 		}
	// 	}
	// }
}


export default listGeneral;